<script lang="ts">import { getIcon } from "../data/icons";
export let size = 24;
export let icon = "InfoIcon";
const iconComponent = getIcon(icon);
</script>

{#if typeof iconComponent === 'function'}
	<svelte:component this={iconComponent} width={size} height={size} {size} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
